document.addEventListener('DOMContentLoaded', function () {
    // Verifica si la URL contiene '.pt' o '.it' para identificar que es el sitio en portugués o italiano
    var domain = window.location.href;
    if (domain.includes('.pt') || domain.includes('.it')) {
        // Elimina el elemento con la clase .wa__widget_container
        var widgetContainer = document.querySelector('.wa__widget_container');
        if (widgetContainer) {
            widgetContainer.remove();
        }
    }
});
